import React, { useMemo } from 'react';
import { AppIcon, HeaderLayout, PageLayout } from "@components";

export interface SystemPageLayoutProps {
	content?: JSX.Element,
}

function SystemPageLayout(props: SystemPageLayoutProps): JSX.Element {
    const { content } = props;

    const header = useMemo(() => <HeaderLayout
        content={null}
        trailing={null}
        leading={<AppIcon />}
    />, []);

    return <PageLayout header={header} content={content} />
}

export {SystemPageLayout};